import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PdfBarCodeGenerator } from '../pdf-bar-code-generator';
import { DATE_FORMAT, FormatDate } from '../../../../constants';

interface PdfCredentialDetailsProps {
  data: any;
}

export const PdfVerificationSignatureInformation: React.FC<PdfCredentialDetailsProps> = (props) => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '8px',
      fontFamily: 'Libre Franklin Bold'
    },
    leftColumn: {
      flexDirection: 'row',
      paddingRight: 20,
      paddingLeft: 20,
      marginTop: -15
    },
    row: {
      width: '150%'
    },
    label: {
      flexDirection: 'row',
    },
    subText: {
      fontSize: '8px'
    }
  });

  return (
    <>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          marginTop: '7px'
        }}
      >
        <View
          style={{
            width: '150px',
            maxWidth: '150px',
            minHeight: '75px',
            maxHeight: '75px',
            margin: '0 auto',
            marginLeft: '33%' 
          }}
        >
          {props.data.caseId && <PdfBarCodeGenerator barCodeValue={props.data.caseId} barCodeWidth={1.25} barCodeHeight={90} barCodeFontSize={22} />}
        </View>

        <Text
          style={{
            fontSize: '8px',
            color: 'black',
            textAlign: 'right',
            marginRight: '20px'
          }}
        >
          {FormatDate(new Date())}
        </Text>
      </View>

      <View style={styles.leftColumn}>
        <View style={styles.row}>
          <View style={styles.label}>
            <Text style={[styles.text, { marginBottom: 5, width: "110px" }]}>Name of Record: &nbsp; </Text>
            <Text style={[styles.subText, {width: "350px", marginLeft: "-10px"}]}>{props.data.applicantName}</Text>
          </View>
          <View style={styles.label}>
            <Text style={[styles.text, { marginBottom: 5, width: "140px" }]}>Name on Credential: &nbsp; </Text>
            <Text style={[styles.subText, {width: "350px", marginLeft: "-10px"}]}>{props.data.nameOnCredential}</Text>
          </View>
        </View>
        <View
          style={{
            width: '100%',
          }}
        >
          <View style={styles.label}>
            <Text style={[styles.text, { marginBottom: 5 }]}>Date of Birth: &nbsp; </Text>
            <Text style={styles.subText}>{FormatDate(props.data.dateOfBirth, DATE_FORMAT)}</Text>
          </View>
          {props.data.applicantId && (
            <View style={styles.label}>
              <Text style={styles.text}>CVHP ID: &nbsp; </Text>
              <Text style={styles.subText}>{props.data.applicantId}</Text>
            </View>
          )}
        </View>
      </View>
    </>
  );
};
export default PdfVerificationSignatureInformation;
